import React from 'react'
import PropTypes from 'prop-types'

const ActionButton = ({ className, children, ...rest }) => {
  return (
    <div className={'flex-center-wrapper'}>
      <button type={'button'} className={className} {...rest}>
        { children }
      </button>
    </div>
  )
}

ActionButton.propTypes = {
  children: PropTypes.any.isRequired,
  className: PropTypes.string,
  type: PropTypes.string,
}

ActionButton.defaultProps = {
  className: 'action-button',
}

const SvgActionButton = ({ className, imgFile, height, width, alt, type, ...rest }) => {
  return (
    <div className={'flex-center-wrapper'} style={{ display: 'inline-block', filter: 'none', isolation: 'isolate', width: '100%' }} >
      <button type={type} className={className} {...rest}>
        <img src={imgFile} height={height || 55} width={width || 200} alt={alt} />
      </button>
    </div>
  )
}

SvgActionButton.propTypes = {
  className: PropTypes.string,
  imgFile: PropTypes.string,
  height: PropTypes.number,
  width: PropTypes.number,
  alt: PropTypes.string,
  type: PropTypes.string,
}

SvgActionButton.defaultProps = {
  className: 'svg-button',
}

const SecondaryActionButton = (props) =>
  <ActionButton className={'action-button secondary'} {...props} />

// TODO: Find better name
const SmallerTextActionButton = (props) =>
  <ActionButton className={'action-button long'} {...props} />

// TODO: Find better name
const SmallerTextSecondaryActionButton = (props) =>
  <ActionButton className={'action-button secondary long'} {...props} />

export {
  ActionButton,
  SecondaryActionButton,
  SmallerTextSecondaryActionButton,
  SmallerTextActionButton,
  SvgActionButton,
}
